<template>
	<div>
        <div class="flex justify-between items-center border-b border-gray-200 pb-2 mb-3">
            <h1 class="module-header">Leases</h1>
            <div @click="$modal.show('manage-leases')">
                <button class="ml-3 flex items-center btn btn-small btn-indigo">
                    <inline-svg name="edit" classes="w-4 h-4 text-white fill-current"></inline-svg>
                    <span class="ml-2">Manage Leases</span>
                </button>
            </div>
        </div>

        <div class="flex" :class="{ 'flex-col': fromReatlas, 'lg:flex-row': ! fromReatlas }">
            <div :class="{ 'w-full': fromReatlas, 'lg:w-1/2 lg:mr-6': ! fromReatlas }">
                <div class="flex flex-col">
                    <table class="w-full mb-8" :class="{ 'max-w-lg': ! fromReatlas }">
                        <thead class="cursor-pointer">
                            <tr>
                                <th class="pl-4">Name</th>
                                <th class="text-right">Total Sq. Ft.</th>
                                <th class="text-center">Start</th>
                                <th class="text-center">End</th>
                            </tr>
                        </thead>
                        <tbody v-if="sites.selectedSite.leases.length">
                            <tr
                                v-for="lease in sites.selectedSite.leases" :key="lease.id"
                                @click="selectedLeaseId = lease.id"
                                :class="{
                                    'highlight-on-hover cursor-pointer': leases.all.length > 1,
                                    highlighted: leases.all.length > 1 && selectedLeaseId == lease.id
                                }">
                                    <td class="pl-4">{{ lease.name }}</td>
                                    <td class="text-right">{{ lease.total_square_feet | number }}</td>
                                    <td class="text-center">{{ lease.start_date | date }}</td>
                                    <td class="text-center">{{ lease.end_date | date }}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="6" class="text-center text-sm">No Leases Found</td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="selectedLeaseId">
                        <h3 class="text-base mb-2 border-b border-dashed border-gray-300 pb-2" :class="{ 'max-w-lg': ! fromReatlas }">
                            <span class="font-normal">Units for</span>
                            <span class="text-indigo-600"> {{ leases.selectedLease ? leases.selectedLease.name : '' }}</span>
                        </h3>
                        <table class="w-full" :class="{ 'max-w-lg': ! fromReatlas }">
                            <thead>
                                <tr>
                                    <th class="text-center">Floor</th>
                                    <th class="text-center">Suite</th>
                                    <th class="text-right">Size</th>
                                    <th class="text-right">Divisible</th>
                                    <th class="text-right">TI Allowance</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody v-if="leases.selectedLease?.units?.length">
                                <tr v-for="(unit, unitIndex) in leases.selectedLease.units" :key="unitIndex">
                                    <td class="text-center">{{ unit.floor }}</td>
                                    <td class="text-center">{{ unit.suite }}</td>
                                    <td class="text-right">{{ formatNumber(unit.pivot.leased_square_footage) }}</td>
                                    <td class="text-right">{{ formatNumber(unit.divisible) }}</td>
                                    <td data-precision="2" :data-originalvalue="unit.ti_allowance" class="is-currency text-right">{{ formatCurrency(unit.ti_allowance, 2) }}</td>
                                    <td class="text-center max-w-xs">
                                        <v-popover v-if="unit.comment" trigger="hover click" offset="10">
                                            <inline-svg name="note"></inline-svg>

                                            <template slot="popover">
                                                <div class="leading-normal max-w-sm p-6">
                                                    {{ unit.comment }}
                                                </div>
                                            </template>
                                        </v-popover>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="6" class="text-center text-sm">No Units Found</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div :class="{ 'mt-10 w-full': fromReatlas, 'lg:mt-0  lg:w-1/2': ! fromReatlas }">
                <stack-chart
                    :data="sites.selectedSite.stack"
                    is-site>
                </stack-chart>
            </div>
        </div>

        <notifications classes="notification" position="bottom right"></notifications>
	</div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'ReoptLeases',

        props: {
            data: {
                type: [Array, Object],
                required: true
            },

            fromReatlas: {
                type: Boolean,
                default: false
            }
        },
        
    	data() {
    		return {
                selectedLeaseId: this.data.leases[0] ? this.data.leases[0].id : '',
    		}
    	},

        created() {
            this.leases.all = this.data.leases;
            this.leases.filtered = this.data.leases;
            this.leases.selectedLease = _.find(this.data.leases, ['id', this.selectedLeaseId]);
            this.sites.selectedSite = this.data;
        },

        watch: {
            selectedLeaseId() {
                this.leases.selectedLease = _.find(this.sites.selectedSite.leases, ['id', this.selectedLeaseId]);
            }
        },

        computed: {
            ...mapState(['leases']),
            ...mapState(['sites']),
        }
    }
</script>